const PDF_IMAGE_FORMATS = {
  'image/jpeg': 'JPEG',
  'image/png': 'PNG',
  'image/webp': 'WEBP',
};

const normalizeContentType = (value) =>
  String(value || '')
    .split(';', 1)[0]
    .trim()
    .toLowerCase();

export const loadPdfImage = async (
  url,
  {
    fetchImpl = fetch,
    imageFactory = () => new Image(),
    createObjectURL = URL.createObjectURL.bind(URL),
    revokeObjectURL = URL.revokeObjectURL.bind(URL),
  } = {}
) => {
  if (typeof url !== 'string' || !url.trim()) return null;

  let response;
  try {
    response = await fetchImpl(url, { credentials: 'same-origin' });
  } catch (_) {
    return null;
  }

  const contentType = normalizeContentType(
    response?.headers?.get?.('content-type')
  );
  const format = PDF_IMAGE_FORMATS[contentType];
  if (!response?.ok || !format) return null;

  let blob;
  try {
    blob = await response.blob();
  } catch (_) {
    return null;
  }
  if (!blob || blob.size <= 0) return null;

  let objectUrl;
  try {
    objectUrl = createObjectURL(blob);
  } catch (_) {
    return null;
  }

  try {
    const image = imageFactory();
    await new Promise((resolve, reject) => {
      image.onload = resolve;
      image.onerror = reject;
      image.src = objectUrl;
    });
    if (!image.naturalWidth || !image.naturalHeight) return null;
    return { format, image };
  } catch (_) {
    return null;
  } finally {
    try {
      revokeObjectURL(objectUrl);
    } catch (_) {
      // Object URL cleanup must not turn an otherwise valid export into a failure.
    }
  }
};
